// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SimpleSelect_select__pvP0h {
  position: relative;
  font-size: var(--fz-sm);
  line-height: var(--lh-sm);
}
.SimpleSelect_select--is-open__4rxAu .SimpleSelect_iconWrap__vaWdp {
  transform: scaleY(-1);
}
.SimpleSelect_select--lang__9EZ0p .SimpleSelect_btn__dR\\+Sb {
  width: auto;
  height: 24px;
}
.SimpleSelect_select--lang__9EZ0p .SimpleSelect_btn__dR\\+Sb img {
  object-fit: cover;
  object-position: center;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1607843137);
  border: 1px solid var(--white);
  transition: var(--transition);
  transition-property: box-shadow;
}
@media (hover: hover) {
  .SimpleSelect_select--lang__9EZ0p .SimpleSelect_btn__dR\\+Sb:hover img {
    box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.1607843137);
  }
}
.SimpleSelect_select--lang__9EZ0p .SimpleSelect_list__2vETw {
  padding: 4px 8px;
}

.SimpleSelect_btn__dR\\+Sb {
  display: flex;
  align-items: center;
  width: 200px;
  height: 40px;
}

.SimpleSelect_iconWrap__vaWdp {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-left: 2px;
  transition: var(--transition);
}

.SimpleSelect_drop__dR1uZ {
  position: absolute;
  left: 0;
  top: calc(100% + 8px);
  border: 1px solid var(--gray-100);
  border-radius: 4px;
  background-color: var(--white);
  min-width: 100%;
  width: 145px;
  z-index: 10;
}
.SimpleSelect_drop--is-right__YBKJM {
  left: auto;
  right: 0;
}

.SimpleSelect_list__2vETw {
  list-style-type: none;
  padding: 8px;
}

.SimpleSelect_leftIcon__XdFuj {
  flex-shrink: 0;
  width: 19px;
  height: 12px;
  margin-right: 8px;
}
.SimpleSelect_leftIcon__XdFuj img {
  max-width: 100%;
  max-height: 100%;
}

.SimpleSelect_listItem__P01F-:last-child .SimpleSelect_item__wcatF {
  border: none;
}

.SimpleSelect_item__wcatF {
  display: flex;
  align-items: center;
  min-height: 26px;
  width: 100%;
  border-bottom: 1px solid var(--gray-100);
  text-align: left;
  padding: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/Assets/SimpleSelect/SimpleSelect.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,uBAAA;EACA,yBAAA;AACF;AAEI;EACE,qBAAA;AAAN;AAKI;EACE,WAAA;EACA,YAAA;AAHN;AAKM;EACE,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uDAAA;EACA,8BAAA;EACA,6BAAA;EACA,+BAAA;AAHR;AAMM;EAEI;IACE,uDAAA;EALV;AACF;AAUI;EACE,gBAAA;AARN;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAVF;;AAaA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;AAVF;;AAaA;EACE,kBAAA;EACA,OAAA;EACA,qBAAA;EACA,iCAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AAVF;AAYE;EACE,UAAA;EACA,QAAA;AAVJ;;AAcA;EACE,qBAAA;EACA,YAAA;AAXF;;AAcA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAXF;AAaE;EACE,eAAA;EACA,gBAAA;AAXJ;;AAiBI;EACE,YAAA;AAdN;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,wCAAA;EACA,gBAAA;EACA,cAAA;AAhBF","sourcesContent":[".select {\r\n  position: relative;\r\n  font-size: var(--fz-sm);\r\n  line-height: var(--lh-sm);\r\n\r\n  &--is-open {\r\n    .iconWrap {\r\n      transform: scaleY(-1);\r\n    }\r\n  }\r\n\r\n  &--lang {\r\n    .btn {\r\n      width: auto;\r\n      height: 24px;\r\n\r\n      img {\r\n        object-fit: cover;\r\n        object-position: center;\r\n        width: 24px;\r\n        height: 24px;\r\n        border-radius: 100%;\r\n        box-shadow: 0px 4px 4px 0px #00000029;\r\n        border: 1px solid var(--white);\r\n        transition: var(--transition);\r\n        transition-property: box-shadow;\r\n      }\r\n\r\n      @media (hover: hover) {\r\n        &:hover {\r\n          img {\r\n            box-shadow: 0px 8px 8px 0px #00000029;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .list {\r\n      padding: 4px 8px;\r\n    }\r\n  }\r\n}\r\n\r\n.btn {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 200px;\r\n  height: 40px;\r\n}\r\n\r\n.iconWrap {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n  width: 16px;\r\n  height: 16px;\r\n  margin-left: 2px;\r\n  transition: var(--transition);\r\n}\r\n\r\n.drop {\r\n  position: absolute;\r\n  left: 0;\r\n  top: calc(100% + 8px);\r\n  border: 1px solid var(--gray-100);\r\n  border-radius: 4px;\r\n  background-color: var(--white);\r\n  min-width: 100%;\r\n  width: 145px;\r\n  z-index: 10;\r\n\r\n  &--is-right {\r\n    left: auto;\r\n    right: 0;\r\n  }\r\n}\r\n\r\n.list {\r\n  list-style-type: none;\r\n  padding: 8px;\r\n}\r\n\r\n.leftIcon {\r\n  flex-shrink: 0;\r\n  width: 19px;\r\n  height: 12px;\r\n  margin-right: 8px;\r\n\r\n  img {\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n  }\r\n}\r\n\r\n.listItem {\r\n  &:last-child {\r\n    .item {\r\n      border: none;\r\n    }\r\n  }\r\n}\r\n\r\n.item {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: 26px;\r\n  width: 100%;\r\n  border-bottom: 1px solid var(--gray-100);\r\n  text-align: left;\r\n  padding: 0 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": `SimpleSelect_select__pvP0h`,
	"select--is-open": `SimpleSelect_select--is-open__4rxAu`,
	"iconWrap": `SimpleSelect_iconWrap__vaWdp`,
	"select--lang": `SimpleSelect_select--lang__9EZ0p`,
	"btn": `SimpleSelect_btn__dR+Sb`,
	"list": `SimpleSelect_list__2vETw`,
	"drop": `SimpleSelect_drop__dR1uZ`,
	"drop--is-right": `SimpleSelect_drop--is-right__YBKJM`,
	"leftIcon": `SimpleSelect_leftIcon__XdFuj`,
	"listItem": `SimpleSelect_listItem__P01F-`,
	"item": `SimpleSelect_item__wcatF`
};
export default ___CSS_LOADER_EXPORT___;
